import { useColorMode } from "@chakra-ui/react";
import { useEffect } from "react";
import { Dict } from "@chakra-ui/utils";

// Theme
import lightTheme from "theme/lightConfig";
import darkTheme from "theme/darkConfig";

interface PropTypes {
  onChange: (theme?: Dict<any>) => void;
}

/**
 * HandleThemeChange component is to switch/emit theme on colorSchemeChange.
 * ideally this hould be handled Chakra itself.
 * FIX: this is a temporary solution to toggle themes.
 */
const HandleThemeChange = ({ onChange }: PropTypes) => {
  const { colorMode } = useColorMode();

  useEffect(() => {
    onChange(colorMode === "dark" ? darkTheme : lightTheme);
  }, [colorMode]);

  return null;
};

export default HandleThemeChange;
